import styled, { useTheme } from 'styled-components'
import { Text } from '@/components/common'
import { LayoutHeader } from '@/components/domains/layouts'
import { FrequentlyBoughtProductListV2 } from '@/components/domains/mypage/frequently-bought-product-list-v2'

interface PageFrequentlyListProps {
  isPage?: boolean
}

const PageFrequentlyList = ({ isPage = true }: PageFrequentlyListProps) => {
  const { color, fontWeight } = useTheme()

  return (
    <StyledContainer>
      {isPage && <LayoutHeader />}
      {isPage && (
        <TextContainer>
          <Text.Body4 fontWeight={fontWeight.regular} fontColor={color.gray500}>
            구매한 수가 동일한 경우 최근에 구매한 상품이 먼저 정렬돼요.
          </Text.Body4>
        </TextContainer>
      )}
      <>
        <FrequentlyBoughtProductListV2 isPage={isPage} />
      </>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  padding-bottom: 4.8rem;
`

const TextContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.size12} ${({ theme }) => theme.spacing.size16};
  background-color: ${({ theme }) => theme.color.gray50};
`

export default PageFrequentlyList
